import request from "@/utils/request";

export default function unbindCamera(id) {
    return request({
        url: `/camera/unbind/${id}`,
        method: 'get'
    })
}